// Mirrors impire-sdk-go/billing/billing.go — the billing family's wire
// (02-DESIGN/18-billing/01-the-billing-service.md § the catalogue, § the
// subscription, § billing details and VAT, § the ledger, § the verbs;
// decision 0073): the subjects a root's admin speaks, the codes, the
// states, and the bodies, all the library's (@impire-io/sdk `billing`). JSON
// field names are the Go file's; a shape that differs is a defect here. A
// subject is built by the library, never inlined.

import { billing } from "@impire-io/sdk";

/** SERVICE is the billing service's micro service name, under which callers discover its sealing key. */
export const SERVICE = billing.SERVICE;

/** The subjects the Billing tab, Home and a receipt's page speak, the tokenless form; the import fills the account. */
export const Subjects = {
  catalogueGet: () => billing.catalogueGetSubject(),
  subscriptionGet: () => billing.subscriptionGetSubject(),
  detailsPut: () => billing.detailsPutSubject(),
  changePreview: () => billing.changePreviewSubject(),
  changeApply: () => billing.changeApplySubject(),
  methodChange: () => billing.methodChangeSubject(),
  retry: () => billing.retrySubject(),
  cancel: () => billing.cancelSubject(),
  cancelUndo: () => billing.cancelUndoSubject(),
  chargesList: () => billing.chargesListSubject(),
} as const;

/** LONG is the wait of a verb that may wait on the payment provider or the VAT register (the Go client's 30 s). */
export const LONG = billing.LONG_TIMEOUT;

export const Code = billing.Code;
export const State = billing.State;
export const ChargeStatus = billing.ChargeStatus;
export const Direction = billing.Direction;
export const Treatment = billing.Treatment;
export const LineKind = billing.LineKind;
export const rootOf = billing.rootOf;

export type Catalogue = billing.Catalogue;
export type CatalogueReply = billing.CatalogueReply;
export type Plan = billing.Plan;
export type AddOn = billing.AddOn;
export type Change = billing.Change;
export type Subscription = billing.Subscription;
export type SubscriptionReply = billing.SubscriptionReply;
export type Details = billing.Details;
export type DetailsPutRequest = billing.DetailsPutRequest;
export type DetailsReply = billing.DetailsReply;
export type Address = billing.Address;
export type Amount = billing.Amount;
export type Line = billing.Line;
export type PreviewReply = billing.PreviewReply;
export type ApplyRequest = billing.ApplyRequest;
export type ApplyReply = billing.ApplyReply;
export type MethodChangeReply = billing.MethodChangeReply;
export type RetryReply = billing.RetryReply;
export type CancelReply = billing.CancelReply;
export type Charge = billing.Charge;
export type ChargesListRequest = billing.ChargesListRequest;
export type ChargesListReply = billing.ChargesListReply;
